import { DynamicPropertyType } from 'types/DynamicPropertyType';

import UnitNumber from './UnitNumber';

export default class Pixels extends UnitNumber {
    type = DynamicPropertyType.PIXELS;
    unit = 'px';
}
